<div class="page-container no-scroll h-100">
    <div class="header" [class.activeSearch]="inSearchState">
        <app-header title="{{ 'document.documents' | translate }}" [hideOverflow]="true" />
        <!-- Search Bar -->
        <app-search #searchBar placeholder="document.searchDocuments" (onSearch)="onSearch($event)"></app-search>
        <div @widthExpand *ngIf="inSearchState && !inRecentDocumentsState">
            <ui-button size="mobile-shrink" class="clear-search" type="ghost" (click)="onClearSearchFilters()">
                <mat-icon svgIcon="close" />
                <span class="only-large">{{ 'document.clear' | translate }}</span>
            </ui-button>
        </div>
        @if (parentDrive?.type === driveTypeEnum.employee) {
            <ui-button
                [aria-label]="'account.addDocument' | translate"
                class="create-new"
                type="primary"
                (click)="onAddEmployeeDocument()"
                ><mat-icon svgIcon="plus" /><mat-icon class="file-icon hide-large" svgIcon="file" /><span
                    class="only-large"
                    >{{ 'account.addDocument' | translate }}</span
                ></ui-button
            >
        }
    </div>

    <ui-banner *ngIf="incompleteDocumentCount > 0" variant="info" class="mobile-hide"
        >{{ 'account.incompleteDocumentCountBanner' | translate: { incompleteDocumentCount } }}
    </ui-banner>

    <ui-card class="document-folders-index-view" [withSpacing]="false">
        <!-- Sidebar -->
        <div class="sidepanel">
            <div
                role="button"
                class="quick-link mobile-hide"
                [class.recent-documents-selected]="inRecentDocumentsState"
                (click)="onRecentDocuments()"
            >
                <mat-icon class="icon" svgIcon="clockSimple"></mat-icon>
                <span>{{ 'account.recentDocuments' | translate }}</span>
            </div>
            <div
                role="button"
                class="quick-link mobile-hide"
                [class.recent-documents-selected]="isIncompleteView()"
                (click)="onIncompleteDocument()"
            >
                <mat-icon class="icon" svgIcon="edit"></mat-icon>
                <span
                    >{{ 'account.signingRequests' | translate }}
                    <span *ngIf="incompleteDocumentCount > 0" class="margin-left-1 counter"
                        ><div class="counter-number">{{ incompleteDocumentCount }}</div></span
                    ></span
                >
            </div>
            <div class="divider mobile-hide"></div>
            <app-document-folders-sidebar-v2
                class="folders-sidebar"
                #sidebarComponent
                [allowDragAndDrop]="false"
                [showMeatballs]="false"
                [tableParentNode]="tableParentNode"
                [sidebarDrives]="sidebarDrives"
                (loadTableBasedOnSelectedNode)="onClearSearchFilters(); load($event)"
                (reloadTableOnSideBarActions)="onClearSearchFilters(); table.reload()"
                [deselectEverything]="inSearchState || isIncompleteView()"
                (recentDocumentsClicked)="onRecentDocuments()"
                [inRecentDocumentsState]="inRecentDocumentsState"
                (incompleteDocumentsClicked)="onIncompleteDocument()"
                [isIncompleteView]="isIncompleteView()"
            ></app-document-folders-sidebar-v2>
        </div>

        <!-- Table -->
        <div class="folders-index-table loadable" [class.loading]="isLoading || isTableLoading || isSearchTableLoading">
            <div class="table-header">
                <div class="header-wrapper">
                    <!-- Breadcrumb navigation -->
                    @if (!inSearchState && !isIncompleteView()) {
                        <div class="breadcrumb only-large">
                            @for (crumb of breadcrumb; track crumb; let isFirst = $first) {
                                @if (!isFirst) {
                                    <mat-icon svgIcon="chevronRight"></mat-icon>
                                }
                                @if (crumb.node) {
                                    <a (click)="onClick(crumb.node)"
                                        ><span>{{ maybeSystemFolder(crumb.name) | translate }}</span></a
                                    >
                                } @else if (isFirst) {
                                    <a (click)="onRecentDocuments()"
                                        ><span>{{ crumb.name | translate }}</span></a
                                    >
                                } @else {
                                    <span>{{ crumb.name | translate }}</span>
                                }
                            }
                        </div>
                    }

                    <div class="header-details">
                        @if ((inSearchState && searchQuery) || inRecentDocumentsState || isIncompleteView()) {
                            <!-- Search Header -->
                            <h2>
                                <span>
                                    @if (inSearchState && searchQuery) {
                                        {{ 'document.searchResultsSearchQuery' | translate: { searchQuery } }}
                                    } @else if (inRecentDocumentsState) {
                                        {{ 'account.recentDocuments' | translate }}
                                    } @else if (isIncompleteView()) {
                                        {{ 'account.signingRequests' | translate }}
                                    }
                                </span>
                            </h2>
                        } @else {
                            <!-- Header based on public or employee drive or folder -->
                            @if (tableParentNode?.isDrive()) {
                                @if (parentDrive?.type === driveTypeEnum.public) {
                                    <h2>
                                        <span>{{ driveTypeDisplay['public'] | translate }}</span>
                                    </h2>
                                } @else {
                                    <h2>
                                        <span>{{ driveTypeDisplay['employee'] | translate }}</span>
                                    </h2>
                                }
                            } @else if (tableParentNode?.isFolder()) {
                                <h2>
                                    <span>{{ maybeSystemFolder(tableParentNode?.name ?? '') | translate }}</span>
                                </h2>
                            }
                        }

                        <div>
                            <!-- Paginator -->
                            @if (!inSearchState && table?.paginator) {
                                <app-pagination
                                    [total]="table.paginator.total"
                                    [current]="table.paginator.page"
                                    [limit]="table.paginator.pageSize"
                                    (pageChange)="table.paginator.page = $event"
                                    [disableLoad]="isLoading"
                                />
                            } @else if (tableBasedOnSearchQuery?.paginator) {
                                <app-pagination
                                    [total]="tableBasedOnSearchQuery.paginator.total"
                                    [current]="tableBasedOnSearchQuery.paginator.page"
                                    [limit]="tableBasedOnSearchQuery.paginator.pageSize"
                                    (pageChange)="tableBasedOnSearchQuery.paginator.page = $event"
                                    [disableLoad]="isLoading"
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div [class.scrollable-table-container]="!isMobile">
                @if (inSearchState && tableBasedOnSearchQuery) {
                    <!-- On Search or tags filter, load table based on search query -->
                    <app-table
                        (rowClicked)="onClick($event)"
                        [noPadding]="true"
                        [useStickyHeader]="false"
                        [showOffset]="false"
                        [showActionsPadding]="false"
                        [embedded]="true"
                        *ngIf="!isLoading && !isSearchTableLoading"
                        [table]="tableBasedOnSearchQuery"
                        class="table"
                        [showSearch]="false"
                        (menuItemSelected)="menuAction($event)"
                        [isResponsive]="true"
                        [showPagination]="false"
                    >
                        <app-empty-state
                            class="empty-state"
                            src="/assets/illustrations/documents_empty.png"
                            label="document.thisFolderIsEmpty"
                        ></app-empty-state>
                    </app-table>
                } @else {
                    <!-- Not in search mode or tags filter mode, load normal table -->
                    <app-table
                        (rowClicked)="onClick($event)"
                        [noPadding]="true"
                        [useStickyHeader]="false"
                        [showOffset]="false"
                        [showActionsPadding]="false"
                        [embedded]="true"
                        *ngIf="!isLoading && !isTableLoading"
                        [table]="table"
                        class="table"
                        [showSearch]="false"
                        (menuItemSelected)="menuAction($event)"
                        [isResponsive]="true"
                        [showPagination]="false"
                    >
                        <app-empty-state
                            class="empty-state"
                            src="/assets/illustrations/documents_empty.png"
                            label="{{ 'account.thisFolderIsEmpty' | translate }}"
                        ></app-empty-state>
                    </app-table>
                }
            </div>
        </div>
    </ui-card>
</div>
